import React from 'react'
import BookRideSection from '../components/sections/BookRideSection'
import useMeta from '../hooks/useMeta';
import Meta from '../components/common/Meta';

const RefundPolicy = () => {
   const meta = useMeta("refund-policy");
    // console.log("refund-policy Page Meta:", meta);
    return (
        <>
            {/* Meta tags for SEO */}
            {meta && (
                <Meta
                    title={meta.meta_title}
                    description={meta.meta_description}
                    keywords={meta.meta_keywords}
                />
            )}
         <section className="terms_conditions section_pt section_pb">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="privacy_section">
                        <h2 className="title">Refund Policy</h2>
                        <p><small> At Orbicabs, we strive to offer a fair and flexible refund process for all
                                pre-booked transport services. This policy outlines when and how customers may be
                                eligible for a refund.</small></p>
                        <br/>

                        <h4>1. General Refund Conditions</h4>
                        <p>Refunds are applicable only for prepaid bookings made through our website or mobile app.
                            Refund amounts and conditions may vary based on the ride type.</p>

                        <h4>2. If No Transporter Is Assigned</h4>
                        <p>If we are unable to assign a transporter to your booking:</p>
                        <ul>
                            <li>✅ 100% refund will be issued automatically.</li>
                            <li>✅ Refund will be processed to your original payment method within 5–7 business days.
                            </li>
                        </ul>

                        <h4>3. City Rides / Airport Transfers / One-Way Rides</h4>
                        <table className="refund-table" aria-label="Cancellation Time and Refund Eligibility">
                            <thead>
                                <tr>
                                    <th>Cancellation Time</th>
                                    <th>Refund Eligibility</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td data-label="Cancellation Time">≥ 12 hours before scheduled pickup</td>
                                    <td data-label="Refund Eligibility"><span className="refund-yes">✅ Full refund</span>
                                    </td>
                                </tr>

                                <tr>
                                    <td data-label="Cancellation Time">&lt; 12 hours before pickup</td>
                                    <td data-label="Refund Eligibility"><span className="refund-no">❌ No refund (unless
                                            exception)</span></td>
                                </tr>

                                <tr>
                                    <td data-label="Cancellation Time">Driver no-show / transporter cancel</td>
                                    <td data-label="Refund Eligibility"><span className="refund-yes">✅ Full refund</span> +
                                        <strong>₹50 wallet credit</strong> (optional goodwill)</td>
                                </tr>
                            </tbody>
                        </table>

                        <h4>4. Tour Packages (Full-Day or Multi-Day Rides)</h4>
                        <table className="refund-table" aria-label="Cancellation Time and Refund Eligibility">
                            <thead>
                                <tr>
                                    <th>Cancellation Time</th>
                                    <th>Refund Eligibility</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td data-label="Cancellation Time">≥ 48 hours before start:</td>
                                    <td data-label="Refund Eligibility"><span className="refund-yes">✅ Full refund</span>
                                    </td>
                                </tr>

                                <tr>
                                    <td data-label="Cancellation Time">&lt; 24–48 hours before start:</td>
                                    <td data-label="Refund Eligibility"><span className="refund-no">🔁 80% refund or reschedule</span></td>
                                </tr>

                                <tr>
                                    <td data-label="Cancellation Time">&lt; 24 hours before start:</td>
                                    <td data-label="Refund Eligibility"><span className="refund-yes">❌ No refund</span></td>
                                </tr>
                                <tr>
                                    <td data-label="Cancellation Time">&lt; Tour not delivered (driver no-show):</td>
                                    <td data-label="Refund Eligibility"><span className="refund-yes">✅ Full refund</span></td>
                                </tr>
                            </tbody>
                        </table>
                        <p>Rescheduling is subject to availability and may incur a fare difference.</p>

                        <h4>5. Office Commute Plans (Weekly / Monthly)</h4>
                        <ul>
                            <li>You may defer a ride to the next working day (e.g., in case of leave/WFH).</li>
                            <li>Deferred rides are not deducted from your plan.</li>
                            <li>Rides not used and not deferred will be considered consumed.</li>
                            <li>No refund is provided for unused rides within plan validity.</li>
                            <li>If the platform fails to assign a transporter, that day's ride is:
                                <ul>
                                    <li>✅ Refunded (pro-rata) OR</li>
                                    <li>✅ Auto-added back to your plan</li>
                                </ul>
                            </li>
                        </ul>

                        <h4>6. Refund Process</h4>
                        <ul>
                            <li>All refunds are initiated to the original payment source (e.g., UPI, card, wallet).</li>
                            <li><strong>Refund timelines:</strong></li>
                            <ul>
                                <li>UPI/Card: 3–7 business days</li>
                                <li>Wallet: Instant</li>
                            </ul>
                            <li>You will be notified via email/app when your refund is processed.</li>
                        </ul>

                        <h4>7. Force Majeure & Exceptions</h4>
                        <p>No refund will be provided for delays or cancellations caused by:</p>
                        <ul>
                            <li>Weather conditions, natural disasters, traffic blockades</li>
                            <li>Government restrictions or strikes</li>
                            <li>Incorrect or incomplete pickup information entered by the customer</li>
                        </ul>
                        <p>However, we may issue goodwill credits at our discretion.</p>

                        <h4>8. How to Request a Refund</h4>
                        <p>If you believe you’re eligible for a refund and have not received it automatically, you can:
                        </p>
                        <ul>
                            <li>📧 Email us at: <strong>support@orbicabs.com</strong></li>
                            <li>📱 Use the in-app support ticket system</li>
                        </ul>
                        <p>Please include your booking ID, date, and reason for the refund request.</p>

                        <h4>9. Policy Updates</h4>
                        <p>We may revise this policy periodically. The latest version will always be available on our
                            website and app.</p>

                        <br/>
                        <p><strong>Contact Us:</strong></p>
                        <p>
                            📞 +91 75 3505 1511<br/>
                            📞 +91 90 4136 4870<br/>
                            📧 support@orbicabs.com<br/>
                            🤝 partner@orbicabs.com
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>


    {/* book ride section */}
    <BookRideSection />
    </>
  )
}

export default RefundPolicy